import * as api from 'api/tithes'

export const CONFIRM_TITHE = 'CONFIRM_TITHE'
export const CANCEL_TITHE = 'CANCEL_TITHE'

export const confirmTithe = (id) => ({
  type: CONFIRM_TITHE,
  payload: api.confirmTithe(id)
})

export const cancelTithe = (id) => ({
  type: CANCEL_TITHE,
  payload: api.destroyTithe(id)
})
